export const LFKeywords = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.00063 8.99975H9.1218M18.0015 21.6L11.3087 15.0024C10.0135 15.5043 8.46613 15.3072 7.02861 14.8866C3.60506 13.8851 1.65332 10.3374 2.66927 6.96247C3.68522 3.58758 7.28414 1.66357 10.7077 2.66508C14.1312 3.6666 16.083 7.21437 15.067 10.5893L14.9076 11.4546L21.6004 18.0522V21.6H18.0015Z"
          stroke="#28287B"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
